export const copy = (content) => {
    const oTextarea = document.createElement('textarea');  // 改用 textarea
    oTextarea.value = content;
    document.body.appendChild(oTextarea);
    oTextarea.select();
    oTextarea.readOnly = true;
    oTextarea.id = 'copyInp';
    document.execCommand('Copy');
    oTextarea.blur();
    oTextarea.style.display = 'none';
}